  <div class="search-filter-card vt-tabs position-left pl-0 py-2">
    <p class="d-none py-1 px-2 border-bottom">
      {{mls.languageText?.search_filter?.key1}}<span *ngIf="mls.is_lskey_display == 1">(search_filter.key1)</span>
    </p>
    <ul class="tab-items mb-0 pl-0 " *ngFor="let filter of filterData[0]?.list">
      <li class="text-left px-0">
        <label [ngClass]="{'active': selected_filter==filter?.value }"  (click)="applyFilter(filter)">
          <div class="d-none">
            <input  [checked]="selected_filter==filter?.value"
              (click)="applyFilter(filter)" type="radio" name="filterData[0].key">
            <span class="d-none"></span>
          </div>
          <div [dataTestId]="filter.value" [dataTestIdName]="dataTestId.SEARCH_FILTER_NAME">
            <p class="heading-4"><span [ngClass]="{'color-grey-500': selected_filter!=filter?.value}">              
             {{filter?.name}}</span></p>
          </div>
        </label>
      </li>
    </ul>
  </div>